/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
// import Button from '@mui/material/Button';
// import InputField from "../InputField";
// import styled from "styled-components";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox, Grid, Switch } from "@mui/material";
import * as Sentry from "@sentry/react";
import BasicDatePicker from "../../../components/DatePicker/BasicDatePicker";
import Button from "../../../components/Layout/Button/index";
// import InputField from "../../../components/Layout/InputField";
import AutoCompleteDropdown from "../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import { SERVICES } from "../../../components/Layout/Services";
import { get } from "../../../components/Layout/ApiHandler/apihandler";
import InputField from "../../../components/Layout/fieldInput/InputField";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  //   width: 400,
  // width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "5px",
  boxShadow: 24,
  p: 4,
};
// const DateContainer = styled.div`
//   display: flex;
//   gap: 50px;
//   // padding: 24px;
//   justify-content: flex-start;
// `;
// const Text = styled.p`
//   color: #484848;
//   font-size: 16px;
//   font-weight: 400;
//   text-align: center;
// `;
// const FieldWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   gap: ${(props) => props.customGap || "10px"};
//   align-self: stretch;
// `;
// const Astrick = styled.span`
//   color: red;
// `;

function CycleModal({
  isOpen,
  handleClose,
  handleSubmit,
  onChange,
  heading,
  // placeholder,
  contName,
  dateFrom,
  dateTo,
  onDateChange,
  isContributionActive,
  onContributionToggle,
  isDefault,
  onDefaultChange,
  onSelectReceipt,
  selectedReceiptType,
  editObject,
}) {
  //   const [isContributionActive, setContributionActive] = useState(false);
  const [receiptTypes, setReceiptTypes] = useState([]);
  // console.log(editObject);
  const handleContributionToggle = () => {
    onContributionToggle(!isContributionActive);
  };
  const handleDefaultChange = () => {
    onDefaultChange(!isDefault);
  };
  const getOptions = (options, key) =>
    options?.map((opt) => ({
      ...opt,
      value: opt[key],
    }));
  const handleReceiptTypes = async () => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setReceiptTypes(data.data.receiptTypes);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    handleReceiptTypes();
  }, []);
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalStyle}>
        <h2 id="modal-title">{heading}</h2>
        {/* <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <Text>Contribution Name</Text>
          <InputField
            placeholder={placeholder}
            onChange={onChange}
            customvalue={contName}
          />
        </Box> */}
        {/* <DateContainer>
          <div style={{ display: "flex", gap: "20px" }}>
            <Text>
              Date(From)<Astrick>*</Astrick>
            </Text>
            <BasicDatePicker
              useDefaultBorders
              value={dateFrom}
              onChange={(date) => onDateChange("dateFrom", date)}
            />
          </div>
          <div style={{ display: "flex", gap: "20px" }}>
            <Text>
              Date(To)<Astrick>*</Astrick>
            </Text>
            <BasicDatePicker
              useDefaultBorders
              value={dateTo}
              onChange={(date) => onDateChange("dateTo", date)}
            />
          </div>
        </DateContainer> */}
        {/* <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            marginTop: "20px",
            // justifyContent: "center"
          }}
        >
          <Text>
            Activate Contribution<Astrick>*</Astrick>
          </Text>
          <FormControlLabel
            //   label="Activate Contribution"
            control={
              <Switch
                checked={
                  // editObject.status === "ACTIVE" ? true : isContributionActive
                  isContributionActive
                }
                onChange={handleContributionToggle}
                name="contributionToggle"
              />
            }
          />
        </Box> */}
        {/* <FieldWrapper customGap="20px">
          <Text>Default</Text>
          <FormControlLabel
            control={
              <Checkbox checked={isDefault} onChange={handleDefaultChange} />
            }
          />
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            options={getOptions(receiptTypes, "id")}
            label="Donation Purpose"
            name="receiptTypes"
            value={selectedReceiptType}
            onChange={(selectedValue) => {
              onSelectReceipt(selectedValue?.value);
            }}
            inputProps={{ required: true }}
            useHiddenInput
            style={{ width: "350px" }}
          />
        </FieldWrapper> */}
        {/* <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <Button onClick={handleSubmit}>Submit</Button>
          <Button cancel onClick={handleClose}>
            Cancel
          </Button>
        </Box> */}
        <Box sx={{ width: "100%" }}>
          <Grid container rowSpacing={4} columnSpacing={5}>
            <Grid item xs={6}>
              <InputField
                label="Contribution Name"
                onChange={onChange}
                value={contName}
              />
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={6}>
              <BasicDatePicker
                useDefaultBorders
                value={dateFrom}
                onChange={(date) => onDateChange("dateFrom", date)}
              />
            </Grid>
            <Grid item xs={6}>
              <BasicDatePicker
                useDefaultBorders
                value={dateTo}
                onChange={(date) => onDateChange("dateTo", date)}
              />
            </Grid>
            <Grid item xs={6}>
              <AutoCompleteDropdown
                getOptionLabel={(option) => option.name}
                options={getOptions(receiptTypes, "id")}
                label="Donation Purpose"
                name="receiptTypes"
                value={selectedReceiptType}
                onChange={(selectedValue) => {
                  onSelectReceipt(selectedValue?.value);
                }}
                inputProps={{ required: true }}
                useHiddenInput
                style={{ maxWidth: 290 }}
              />
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={6}>
              {/* <Text>
                Activate Contribution<Astrick>*</Astrick>
              </Text> */}
              <FormControlLabel
                label="Activate Contribution"
                // required
                sx={{
                  "& .MuiFormControlLabel-asterisk ": {
                    color: "red",
                  },
                }}
                control={
                  <Switch
                    checked={
                      // editObject.status === "ACTIVE" ? true : isContributionActive
                      isContributionActive
                    }
                    onChange={handleContributionToggle}
                    name="contributionToggle"
                  />
                }
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                label="Default"
                control={
                  <Checkbox
                    checked={isDefault}
                    onChange={handleDefaultChange}
                  />
                }
              />
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <Button onClick={handleSubmit}>Submit</Button>
            <Button cancel onClick={handleClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default CycleModal;
